import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'リフォーム工事の期間はどのくらいかかりますか？',
      answer: '工事内容により異なりますが、キッチンリフォームで3〜5日、バスルームリフォームで4〜7日、全面リフォームで2〜4週間程度が目安です。詳細な工期は現地調査後にお伝えいたします。'
    },
    {
      question: '見積もりは無料ですか？',
      answer: 'はい、お見積もりは無料です。現地調査からお見積もり作成まで、費用は一切かかりません。お気軽にお問い合わせください。'
    },
    {
      question: '岡山市以外でも対応していますか？',
      answer: '岡山市・倉敷市を中心に、岡山県内全域で対応しております。エリアによっては出張費をいただく場合がございますので、詳しくはお問い合わせください。'
    },
    {
      question: '工事中の生活はどうなりますか？',
      answer: '工事箇所により異なりますが、水回りリフォームの場合は仮設設備をご用意いたします。お客様の生活に配慮した工程で進めさせていただきます。'
    },
    {
      question: 'アフターサービスはありますか？',
      answer: '工事完了後も安心してお過ごしいただけるよう、定期点検やメンテナンスサービスを提供しております。不具合があった場合は迅速に対応いたします。'
    },
    {
      question: '支払い方法はどのようになりますか？',
      answer: '現金、銀行振込、各種クレジットカード、リフォームローンに対応しております。お客様のご都合に合わせた支払い方法をご提案いたします。'
    }
  ];

  return (
    <section className="py-12 sm:py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-4">
            <strong>よくある質問</strong>
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-600 px-4">
            岡山市・倉敷市でのリフォーム工事について、お客様からよくいただくご質問にお答えします
          </p>
        </div>

        <div className="space-y-3 sm:space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="border border-gray-200 rounded-lg overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-4 sm:px-6 py-3 sm:py-4 text-left bg-gray-50 hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <div className="flex items-center justify-between">
                  <h3 className="font-semibold text-gray-900 pr-4 text-sm sm:text-base">{faq.question}</h3>
                  <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-teal-600 flex-shrink-0 text-lg sm:text-xl`}></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-4 sm:px-6 py-3 sm:py-4 bg-white border-t border-gray-200">
                  <p className="text-gray-700 leading-relaxed text-sm sm:text-base">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
